import {
	Navbar,
	NavbarBrand,
	Container,
	Nav,
	NavLink,
	NavDropdown,
	Button,
} from 'react-bootstrap';
import brandLogo from '../assets/images/sun_logo_transparent.png';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import NavbarToggle from 'react-bootstrap/esm/NavbarToggle';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import LoginForm from './LoginForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/axiosConfig';
import { useLocation } from 'react-router-dom';

const NavigationBar = () => {
	const api = API();
	const { user, logout, isAuthenticated, showLogin, setShowLogin } = useAuth();
	const navigate = useNavigate();
	const ourFirm = useRef(null);
	const practiceAreas = useRef(null);
	const pnc = useRef(null);
	const profile = useRef(null);
	const blankLink = useRef(null);

	//Run everytime location changes
	const location = useLocation();
	useEffect(() => {
		console.log('Route changed to ', location.pathname);
	}, [location]);

	//Effect to activate dropdowns for hover use
	useEffect(() => {
		if (profile.current) {
			let promise = new Promise((resolve) => {
				profile.current.children[0].click();
				resolve();
			});
			promise.then(() => {
				closeMenus();
			});
		}
	}, [user, profile]);

	const closeMenus = () => {
		let dropdowns = document.querySelectorAll('.dropdown-menu');
		dropdowns.forEach((element) => {
			element.classList.remove('show');
		});
	};

	const handleLogout = () => {
		api
			.post('/auth/logout')
			.then((res) => {
				logout(); //remove user from application state
			})
			.catch((err) => console.log(err));
	};

	//Navbar collapseOnSelect requires eventKey for each item to work properly
	return (
		<Navbar id="navigation-bar" fixed="top" expand="lg" collapseOnSelect>
			<Container fluid>
				<NavbarBrand>
					<Link to="/" onClick={() => blankLink.current.click()}>
						<img id="navbar-logo" src={brandLogo} />
					</Link>
				</NavbarBrand>
				<NavbarToggle id="main-nav-toggle" aria-controls="main-nav" />
				<NavbarCollapse id="main-nav">
					<Nav className="ms-auto">
						<NavDropdown
							ref={ourFirm}
							className="menu-link"
							title="Our Firm"
							id="our-firm"
							onClick={() => ourFirm.current.blur()}
						>
							<NavDropdown.Item onClick={() => navigate('/about')} eventKey="2">
								<span className="menu-link">About Us</span>
							</NavDropdown.Item>
							<NavDropdown.Item onClick={() => navigate('/team')} eventKey="3">
								<span className="menu-link">Our Team</span>
							</NavDropdown.Item>
						</NavDropdown>
						<NavDropdown
							ref={practiceAreas}
							className="menu-link"
							title="Practice Areas"
							id="practice-areas"
						>
							<NavDropdown.Item onClick={() => navigate('/wills')} eventKey="4">
								<span className="menu-link">Wills</span>
							</NavDropdown.Item>
							<NavDropdown.Item
								onClick={() => navigate('/trusts')}
								eventKey="5"
							>
								<span className="menu-link">Trusts</span>
							</NavDropdown.Item>
							<NavDropdown.Item
								onClick={() => navigate('/probate')}
								eventKey="6"
							>
								<span className="menu-link">Probates</span>
							</NavDropdown.Item>
						</NavDropdown>
						<NavDropdown
							ref={pnc}
							className="menu-link"
							title="Potential New Client"
							id="pnc"
						>
							<NavDropdown.Item
								onClick={() => navigate('/wills-trusts-pnc')}
								eventKey="7"
							>
								<span className="menu-link">Wills & Trusts</span>
							</NavDropdown.Item>
							<NavDropdown.Item
								onClick={() => navigate('/probate-pnc')}
								eventKey="8"
							>
								<span className="menu-link">Probate</span>
							</NavDropdown.Item>
						</NavDropdown>
						<NavLink onClick={() => navigate('/contact')} eventKey="9">
							Contact
						</NavLink>
						{isAuthenticated() ? (
							<NavDropdown
								ref={profile}
								className="menu-link user-dropdown"
								title={<FontAwesomeIcon icon={faUser} />}
							>
								<NavDropdown.Item
									onClick={() => navigate('/profile')}
									eventKey="11"
								>
									<span className="menu-link">Profile</span>
								</NavDropdown.Item>
								<NavDropdown.Item
									onClick={() => navigate('/file-repo')}
									eventKey="12"
								>
									<span className="menu-link">My Files</span>
								</NavDropdown.Item>{' '}
								{user && user.userlevel === 'admin' && (
									<NavDropdown.Item
										onClick={() => navigate('/admin')}
										eventKey="13"
									>
										<span className="menu-link">Admin</span>
									</NavDropdown.Item>
								)}
								<NavDropdown.Item onClick={handleLogout} eventKey="14">
									<span className="menu-link">Logout</span>
								</NavDropdown.Item>
							</NavDropdown>
						) : (
							<NavLink
								onClick={() => setShowLogin(!showLogin)}
								style={{ position: 'relative' }}
							>
								<FontAwesomeIcon icon={faLock} /> Login
							</NavLink>
						)}
						<NavLink ref={blankLink} eventKey="10"></NavLink>
					</Nav>
				</NavbarCollapse>
				<LoginForm showLogin={showLogin} setShowLogin={setShowLogin} />
			</Container>
		</Navbar>
	);
};
export default NavigationBar;
